import { render, staticRenderFns } from "./email-template.vue?vue&type=template&id=9a5067f2&scoped=true&"
import script from "./email-template.vue?vue&type=script&lang=js&"
export * from "./email-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5067f2",
  null
  
)

export default component.exports